import * as React from 'react';
import PageAccordionInterface from '@app/Interface/PageAccordionInterface';
import { PageSection, Accordion, AccordionItem, AccordionContent, AccordionToggle } from '@patternfly/react-core';
import htmlParser from '@app/utils/htmlParser';

interface AccordionProps {
    accordions: PageAccordionInterface[] | boolean
}

const AccordionComponent: React.FC<AccordionProps> = ({ accordions }) => {

    const [expandedItemId, setExpandedItemId] = React.useState("");

    const onToggle = (id: string) => {
        if (id === expandedItemId) {
            setExpandedItemId("");
        } else {
            setExpandedItemId(id);
        }
    }

    /**
     * In order to "map" an array it must be a primitive type of object. 
     * accordians can be an object/array OR boolean. This function narrows down to an object/array
     * see: https://www.typescriptlang.org/docs/handbook/2/narrowing.html
     *  
     * @param accordians Original type with array or boolean value
     * @returns narrows down to just an array
     */
    const narrowAccordionItems = (accordians:  PageAccordionInterface[] | boolean): PageAccordionInterface[]  => {

        let items: PageAccordionInterface[] = [];

        if (typeof accordians === "object") {
            items = accordians;
        }

        return items;

    }

    const items = narrowAccordionItems(accordions);

    return (

        <PageSection>
            <Accordion>
                {items.map((accordion, index) => (
                    <AccordionItem key={index}>
                        <AccordionToggle
                            onClick={() => { onToggle(`ex-toggle-${index}`) }}
                            isExpanded={expandedItemId === `ex-toggle-${index}`}
                            id={`ex-toggle-${index}`}
                        >
                            {accordion.title}
                        </AccordionToggle>
                        <AccordionContent
                            id={`ex-content-${index}`}
                            isHidden={expandedItemId !== `ex-toggle-${index}`}
                        >
                            {/* If the content was provided as an HTML string */}
                            {typeof accordion.content === 'string' &&
                                <div className="pf-c-content">
                                    {htmlParser.htmlToJSX(accordion.content ?? '')}
                                </div>
                            }

                            {/* If the content was provided as JSX */}
                            {typeof accordion.content !== 'string' &&
                                accordion.content
                            }
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </PageSection>
    );

};

export default AccordionComponent;